<template>
  <div>
    <loading :active="isLoading" :is-full-page="fullPage" :loader="loader" />
    <div
      class="modal fade"
      id="UpdateChannelModal"
      tabindex="-1"
      aria-labelledby="UpdateChannelModalLabel"
      aria-hidden="true"
      data-keyboard="false"
      data-backdrop="static"
    >
      <div class="modal-dialog modal-dialog-centered" v-if="showForm">
        <div class="modal-content AddNewChannelModal_content border-0">
          <div class="modal-header AddNewChannelModal_header">
            <h5 class="modal-title" id="UpdateChannelModalLabel">
              <img
                src="../../assets/images/left.svg"
                class="me-2"
                width="20"
                height="20"
              />
              Update Channel
            </h5>
            <button
              type="button"
              class="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
            ></button>
          </div>
          <form @submit.prevent="processForm" method="put">
            <!-- error messages for form validation -->
            <div class="modal-body">
              <div class="mb-3">
                <div class="row align-items-center">
                  <div class="col-12 col-md-4">
                    <label for="c_name" class="form-label">Channel Name</label>
                  </div>
                  <div class="col-12 col-md-8">
                    <input
                      type="text"
                      class="form-control bg-input border-0"
                      name="c_name"
                      v-model="name"
                      id="c_name"
                    />
                  </div>
                </div>
              </div>
              <div class="mb-3">
                <div class="row align-items-center">
                  <div class="col-12 col-md-4">
                    <label for="c_name" class="form-label">Present Image</label>
                  </div>
                  <div class="col-12 col-md-8">
                    <img v-bind:src="channel_img" height="80px" width="120px" />
                  </div>
                </div>
              </div>
              <div class="mb-3">
                <div class="row align-items-center">
                  <div class="col-12 col-md-4">
                    <label for="c_image" class="form-label">Upload Image</label>
                  </div>
                  <div class="col-12 col-md-8">
                    <input
                      class="form-control bg-input border-0"
                      type="file"
                      name="c_image"
                      id="c_image"
                      aria-describedby="imageHelp"
                      accept="image/jpeg, image/png"
                      @change="onImageFileChange"
                    />
                    <div id="imageHelp" class="form-text">
                      * Preferred image ratio 1:1 (ex. 512px * 512px Or 1200px *
                      1200px)
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="modal-footer">
              <button
                type="reset"
                class="btn btn-secondary btn-sm"
                data-bs-dismiss="modal"
              >
                Close
              </button>
              <button type="submit" class="btn btn-primary btn-sm">
                Submit
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import Loading from "vue-loading-overlay";
export default {
  name: "UpdateChannelModal",
  components: { Loading },
  props: ["channel_id", "channel_name", "channel_img"],
  data() {
    return {
      errors: [],
      name: null,
      selectedImageFile: undefined,
      showForm: true,
      //for loader
      isLoading: false,
      fullPage: true,
      loader: "bars",
    };
  },
  methods: {
    onImageFileChange(event) {
      this.selectedImageFile = event.target.files[0];
    },
    processForm() {
      console.log(this.selectedImageFile);
      if (this.selectedImageFile) {
        this.postWithImage();
      } else {
        this.postWithoutImage();
      }
    },
    async postWithImage() {
      this.isLoading = true;
      const formData = new FormData();
      formData.append("name", this.name);
      formData.append("files", this.selectedImageFile);
      const token = localStorage.getItem(this.$tokenKey);
      this.showForm = false;
      try {
        const res = await axios.put(
          this.$baseUrl +
            this.$api +
            this.$version1 +
            "/channels/" +
            this.channel_id,
          formData,
          {
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "multipart/form-data",
            },
          }
        );
        this.isLoading = false;
        console.log(res.data)
        if (res.data.success == true) {
          this.$router.push("/home");
        } else {
          this.$vToastify.info(
            "Something went wrong, please refresh and try again."
          );
        }
      } catch (error) {
        this.isLoading = false;
        console.log(error);
      }
    },
    async postWithoutImage() {
      this.isLoading = true;
      const token = localStorage.getItem(this.$tokenKey);
      // const data = {
      //   name: "kabbik",
      // };
      try {
        const putMethod = {
          method: "PUT", // Method itself
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-type": "application/json; charset=UTF-8", // Indicates the content
          },
          body: JSON.stringify({ name: this.name }), // We send data in JSON format
        };

        //make the HTTP put request using fetch api
        fetch(
          this.$baseUrl +
            this.$api +
            this.$version1 +
            "/channels/" +
            this.channel_id +
            "/without-image",
          putMethod
        )
          .then((response) => response.json())
          .then((data) => {
            console.log(data)
            if (data.success == true) {
               this.$vToastify.success(
                "Successfully updated Channel!!"
              );
              this.$router.go();
            } else {
              this.$vToastify.info(
                "Something went wrong, please refresh and try again."
              );
            }
          }) // Manipulate the data retrieved back, if we want to do something with it
          .catch((err) => console.log(err));
        this.isLoading = false;
        this.showForm = false;
      } catch (error) {
        this.isLoading = false;
        console.log(error);
      }
    },
  },
  watch: {
    channel_name: function (newVal, oldVal) {
      this.name = this.channel_name;
    },
  },
};
</script>


<style scoped>
</style>